import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneInputMaskDirective } from './phone-input-mask.directive';
import { CardNumberInputMaskDirective } from './card-number-input-mask.directive';
import { PreventCopyDirective } from './prevent-copy-cut.directive';
import { PreventPasteDirective } from './prevent-paste.directive';
import { StickyFormButtonsDirective } from './sticky-form-buttons.directive'
import { EllipsifyDirective } from './ellipsify.directive';
import { SSNInputMaskDirective } from './ssn-input-mask.directive';
import { FEINInputMaskDirective } from './fein-input-mask';
import { CardOverlayLoaderDirective } from './card-overlay-loader.directive';
import { AutoFocusIfDirective } from './auto-focus.directive';
import { RestoreFocusDirective } from './restore-focus.directive';
import { TooltipFocusDirective } from './tooltip-focus.directive';
import { ScrollableDirective } from './scrollable.directive';

@NgModule({
    imports: [
        CommonModule,
        PhoneInputMaskDirective,
        SSNInputMaskDirective,
        CardNumberInputMaskDirective,
        PreventCopyDirective,
        PreventPasteDirective,
        StickyFormButtonsDirective,
        EllipsifyDirective,
        FEINInputMaskDirective,
        CardOverlayLoaderDirective,
        AutoFocusIfDirective,
        RestoreFocusDirective,
        TooltipFocusDirective,
        ScrollableDirective
    ],
    exports: [
        PhoneInputMaskDirective,
        SSNInputMaskDirective,
        CardNumberInputMaskDirective,
        PreventCopyDirective,
        PreventPasteDirective,
        StickyFormButtonsDirective,
        EllipsifyDirective,
        FEINInputMaskDirective,
        CardOverlayLoaderDirective,
        AutoFocusIfDirective,
        RestoreFocusDirective,
        TooltipFocusDirective,
        ScrollableDirective
    ],
    providers: []
})
export class DirectivesModule { }
